import { createClient } from '@supabase/supabase-js';
import { currentTenantOrNull } from './lib/tenants';

// Tenant resolution at module load. main.tsx checks the same hostname
// against resolveTenant() and renders TenantNotFoundPage instead of App
// when there's no match — so the dummy URL/key path below should never
// be exercised in practice. We still construct *something* so this
// module's exported `supabase` is always defined and import sites don't
// need null-checks.
//
// Note: we deliberately do NOT add an X-Swiss-Tenant-Host header here.
// Supabase calls go directly to the tenant's Supabase URL — the URL
// itself identifies the tenant, no header needed. Adding a custom
// header would also trigger CORS preflight against the Supabase Kong
// gateway, which doesn't whitelist our app-specific headers.
//
// The header lives on lib/api/core.ts (baseFetch) where it's actually
// useful: backend XHRs go to our shared backend URL where the tenant
// can't be inferred from the URL.
const tenant = currentTenantOrNull();

const supabaseUrl = tenant?.supabaseUrl ?? 'http://invalid-tenant';
const supabaseAnonKey = tenant?.supabaseAnonKey ?? 'invalid';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
